// extracted by mini-css-extract-plugin
export default {"metadata":"knowledge-category_metadata__CToSJ","metadataWrapper":"knowledge-category_metadataWrapper__7XFhz","icon":"knowledge-category_icon__MbOAU"};